import "./button.css";

export const Button = ({ type, href, children, onClick }) => {
  return (
    // <a href={href || "#"} className={`${type !== "news" && 'button'} ${type}`} onClick={onClick}>
    <a href={href || "#"} className={`button ${type}`} onClick={onClick}>
      <>
        <div></div>
        <span>{children}</span>
      </>
    </a>
  );
};
